import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=488994fc&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488994fc')) {
      api.createRecord('488994fc', component.options)
    } else {
      api.reload('488994fc', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=488994fc&", function () {
      api.rerender('488994fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xvs2Q3GelPB1/JS/videoIframe.vue"
export default component.exports